import { useState } from 'react';
// import { initTractsData } from '../helpers/rate/initTractsData';
import { toast } from 'react-toastify';

export default function TractInformationController() {
  const [tractData, updateTractData] = useState(null);
  const clearData = () => updateTractData(null);
  const fetchData = async (place, callback) => {
    updateTractData(null)
    const { formatted_address: address, lat, lng } = place;
    const urlParams = new URLSearchParams({
      address, lat, lng
    });
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/census/tract-info?${urlParams}`);

      if(!response || response.status !== 200) {
        response.json().then(obj => {
          toast.error(obj.message, {position: 'top-center'});
        })
        return;
      }
      
      const tractsData = await response.json();
      // initTractsData(tractsData, tractsData.qualificationThreshold);

      callback && callback(tractsData);
      updateTractData(tractsData);
    }
    catch(err) {
      console.log(err)
    }
  };

  return { tractData, fetchData, clearData };
};
